import { useSelector } from 'react-redux';
import { ProductSection } from 'views/ProductPage/themes/BGH/sections/productSection';
import { ProductFaqs } from 'views/ProductPage/faqs/themes/PP';
import { getNumberOfFaqs } from 'views/ProductPage/selector';
import { rm, NO_ELEMENT, withCurrentPage } from 'utils';

export const FAQ = () => {
  const nbrOfFaqs = useSelector(withCurrentPage(getNumberOfFaqs));

  if (nbrOfFaqs === 0) {
    return NO_ELEMENT;
  }

  return (
    <ProductSection title={rm('product_faq_header')}>
      <ProductFaqs tabletSize="1" phoneSize="1" />
    </ProductSection>
  );
};
